/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import React from 'react';
import { ITaskCreationFlowProps } from '../ModifyServices.Model';

import TaskSourceSelector from './TaskSourceSelector';
import CreateTaskForm from './CreateTaskForm';
import SelectExistingTaskForm from './SelectExistingTaskForm';

const TaskCreationFlow: React.FC<ITaskCreationFlowProps> = (props) => {
  const { selectedOption, nextClick } = props;

  return (
    <>
      {!nextClick && <TaskSourceSelector {...props} />}
      {selectedOption === 'create-new-task' && nextClick && <CreateTaskForm {...props} />}
      {selectedOption === 'select-existing-task' && nextClick && <SelectExistingTaskForm {...props} />}
    </>
  );
};

export default TaskCreationFlow;
